import React, { useState } from 'react';
import { Edit, Delete } from '@mui/icons-material';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import toast from 'react-hot-toast';

const ChatBubble = ({ isOwnMessage, comment }) => {
  const { commentText, edited } = comment;
  console.log(comment, "COMMENT")
  const formattedText = commentText.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ));

  return (
    <>
      <Box
        sx={{
          borderRadius: 3,
          backgroundColor: isOwnMessage ? '#0A4FAC' : '#EEF5FF',
          padding: '8px 12px',
          maxWidth: '85%',
          wordWrap: 'break-word',
          marginLeft: isOwnMessage ? 'auto' : 0,
          marginRight: isOwnMessage ? 0 : 'auto',
          borderTopRightRadius: isOwnMessage ? 0 : null,
          borderTopLeftRadius: isOwnMessage ? null : 0,
        }}
      >
        {edited && (
          <Tooltip title="This feedback has beed edited">
          <Edit
            sx={{
              position: 'absolute',
              right: isOwnMessage ? null : 'calc(40px)',
              left: isOwnMessage ? 'calc(45px)' : null,
              color: 'grey',
              fontSize: '13px',
              transform: 'translateY(5px)',
            }}
            />
            </Tooltip>
        )}

        <Typography variant="body1" color={isOwnMessage ? 'white' : 'black'} fontSize={'15px'} sx={{ whiteSpace: 'pre-wrap' }}>
          {formattedText}
        </Typography>
      </Box>
    </>
  );
};

export default ChatBubble;
